import {useEffect} from 'react'

export default function useSEO({indexable=true}) {
    useEffect(()=>{
        if(!indexable) {
            // Use createElement instead of innerHTML += (avoids re-parsing the whole head)
            const existing=document.head.querySelector('meta[name="robots"]')
            if(!existing) {
                const meta=document.createElement('meta')
                meta.name='robots'
                meta.content='noindex'
                document.head.appendChild(meta)
            }
        } else {
            document.head.querySelectorAll('meta[name="robots"]').forEach(el=>el.remove())
        }
        return ()=>{
            // Cleanup: remove noindex tag when component unmounts
            if(!indexable) {
                document.head.querySelectorAll('meta[name="robots"]').forEach(el=>el.remove())
            }
        }
    },[indexable])
}
